import color from '@theme/Colors';
import React, { SVGProps } from 'react';

type Props = {
    isDisable?: boolean;
} & SVGProps<SVGSVGElement>;

export default function CreateManualPCN(props: Props) {
    return (
        <svg width={20} height={20} viewBox="0 0 24 24" fill='currentColor' xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5v2H5v14h14v-5z" />
            <path d="M21 7h-4V3h-2v4h-4v2h4v4h2V9h4" />
        </svg>
    );
}
